import React, { useEffect, useMemo, useState } from 'react'
import TreeAPI from '../../apis/TreeAPI';
import produce from 'immer';



const useChapters = (props: IUseChaptersProps) => {
    const [chapters, setChapters] = useState<{
        [key: string]: IDBRealtimeChapter | undefined;
    }>({});

    useEffect(() => {
        setChapters({});
        if (props.episodeId === undefined) return;
        const unsubscribe = TreeAPI.subscribeToChapters(
            props.episodeId,
            (chapter: IDBRealtimeChapter) => {
                setChapters(
                    produce(draft => {
                        draft[chapter.id] = chapter;
                    })
                );
            },
            (id: string) => {
                setChapters(
                    produce(draft => {
                        draft[id] = undefined;
                    })
                );
            }
        );
        return () => unsubscribe();
    }, [props.episodeId]);

    const chaptersArray = useMemo(() => {
        const keys = Object.keys(chapters);
        const result: IDBRealtimeChapter[] = [];

        keys.forEach(key => {
            const chapter = chapters[key];
            if(chapter !== undefined)
                result.push(chapter);
        });

        result.sort((a, b) => a.order - b.order);

        return result;
    }, [chapters]);

    return { chapters, chaptersArray };
}

export { useChapters };